var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showMessage)?_c('div',{staticClass:"pull-to-refresh"},[_c('span',[_vm._v(_vm._s(_vm.$t('pullToRefresh.message')))])]):_vm._e(),(!_vm.showMessage)?_c('div',{staticClass:"indicator"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }